<template>
  <session-rating-question-layout :title="title">
    <template>
      <div class="is-flex is-justify-content-center">
        <stars-rating :disabled="false" size="is-large" v-model="value"></stars-rating>
      </div>
    </template>
  </session-rating-question-layout>
</template>

<script>
import SessionRatingQuestionLayout from "@/widgets/agenda/components/rating/SessionRatingQuestionLayout";
import StarsRating from "@/shared/components/common/rating/StarsRating";

export default {
  name: "SessionRatingStarsQuestion",

  components: {SessionRatingQuestionLayout, StarsRating},

  props: {
    rating: {
      type: Object,
      required: true,
    },

    currentResponse: {
      type: Array,
    },
  },

  data() {
    return {
      value: 0,
    };
  },

  computed: {
    title() {
      return this.rating.title;
    },

    ratingId() {
      return this.rating.id;
    },

    answers() {
      return this.rating.agenda_session_rating_answers;
    },

    type() {
      return this.rating.rating_type;
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        if (newValue && newValue > 0) {
          const response = this.answers.find(answer => answer.order === newValue);
          if (response) {
            this.$emit("input", {ratingId: this.ratingId, type: this.type, responses: [response.id]});
          }
        } else {
          this.$emit("input", {ratingId: this.ratingId, type: this.type, responses: null});
        }
      },
    },

    currentResponse: {
      immediate: true,
      handler: function (newValue) {
        if (newValue && newValue.length) {
          const answer = this.answers.find(answer => answer.id === newValue[0]);
          if (answer) {
            this.value = answer.order;
          }
        }
      },
    }

  }
};
</script>

<style scoped>
.rate.is-spaced .rate-item:not(:last-child) {
  margin-right: 0.5rem;
}
</style>
